const breakpoints = {
  desktop: 1920,
  laptop: 1200,
  tablet: 768,
  mobile: 576,
};

export default breakpoints;
